import {LinearProgress} from '@mui/material'
import {memo} from 'react'
import {useTheme} from '@mui/material/styles'

export const PageProgress = memo(() => {
  const theme = useTheme()

  return <LinearProgress sx={{position: 'fixed', width: '100%', left: 0, top: 0, zIndex: theme.zIndex.appBar}}/>
})
